<template>
  <div>
    <div class="wrapper">
      <input type="radio" name="resultado" id="resultado-1" @click="setResultado('total')"/>
      <input type="radio" name="resultado" id="resultado-2" @click="setResultado('ingresos')"/>
      <input type="radio" name="resultado" id="resultado-3" @click="setResultado('gastos')"/>
        <label for="resultado-1" class="resultado resultado-1">
          <div class="dot"></div>
          <span>Total año</span>
        </label>
      <label for="resultado-2" class="resultado resultado-2">
        <div class="dot"></div>
        <span>Ingresos</span>
      </label>
      <label for="resultado-3" class="resultado resultado-3">
        <div class="dot"></div>
        <span>Gastos</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    setResultado: function(option) {
      this.$store.commit("setResultado", option);
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Fira Sans", sans-serif;
}
html,
body {
  display: grid;
  place-items: center;
  background: #0069d9;
  font-family: "Fira Sans", sans-serif;
}
.wrapper {
  background: #fff;
  height: 80px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
}
.wrapper .resultado {
  background: #e0e0e0;
  height: 50px;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  margin-right: 15px;
}

.wrapper .resultado .dot::before {
  position: absolute;
  content: "";
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(1.5);
  transition: all 0.3s ease;
}
input[type="radio"] {
  display: none;
}
#resultado-1:checked:checked ~ .resultado-1,
#resultado-2:checked:checked ~ .resultado-2,
#resultado-3:checked:checked ~ .resultado-3,
#resultado-4:checked:checked ~ .resultado-4,
#resultado-5:checked:checked ~ .resultado-5,
#resultado-6:checked:checked ~ .resultado-6 {
  border-color: #24c6ab;
  background: #24c6ab;
}
#resultado-1:checked:checked ~ .resultado-1 .dot,
#resultado-2:checked:checked ~ .resultado-2 .dot,
#resultado-3:checked:checked ~ .resultado-3 .dot,
#resultado-4:checked:checked ~ .resultado-4 .dot,
#resultado-5:checked:checked ~ .resultado-5 .dot,
#resultado-6:checked:checked ~ .resultado-6 .dot {
  background: #fff;
}
#resultado-1:checked:checked ~ .resultado-1 .dot::before,
#resultado-2:checked:checked ~ .resultado-2 .dot::before,
#resultado-3:checked:checked ~ .resultado-3 .dot::before,
#resultado-4:checked:checked ~ .resultado-4 .dot::before,
#resultado-5:checked:checked ~ .resultado-5 .dot::before,
#resultado-6:checked:checked ~ .resultado-6 .dot::before {
  opacity: 1;
  transform: scale(1);
}

#resultado-1:checked:checked ~ .resultado-1 span,
#resultado-2:checked:checked ~ .resultado-2 span,
#resultado-3:checked:checked ~ .resultado-3 span,
#resultado-4:checked:checked ~ .resultado-4 span,
#resultado-5:checked:checked ~ .resultado-5 span,
#resultado-6:checked:checked ~ .resultado-6 span {
  color: #fff;
}

@media screen and (max-width: 1520px) {
  .wrapper .resultado {
    height: 40px;
    width: 120px;
    font-size: 12px;
  }
}

@media screen and (max-width: 1000px) {
    .wrapper .resultado {
    height: 30px;
    width: 90px;
    font-size: 9px;
  }
}

@media screen and (max-width: 770px) {
  .wrapper .resultado {
    height: 30px;
    width: 80px;
    font-size: 9px;
    margin-right: 8px;
  }
}
</style>
